import { FlexView } from '@cuemath/comps';
import { Button, Dropdown, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import useLogic from './logic';

const AcLedMappingResultFeedback = ({ prospectID, onClose }) => {
  const {
    handleChange,
    reason,
    options,
    submitDisabled,
    handleSubmit,
    isProcessing,
  } = useLogic({
    prospectID,
    onClose,
  });

  return (
    <FlexView gap={24} gutter={24}>
      <Text variant="h4">Did not like the recommended teachers?</Text>
      <Separator height={8} />
      <Text variant="body1Regular">
        Please enter why & also update this in LSQ so that our mappers can find the right
        teacher
      </Text>
      <Separator height={20} />
      <Dropdown
        onChange={value => handleChange(value)}
        label="Please select why"
        value={reason}
        options={options}
        optionsWidth="90%"
        height="auto"
        width="100%"
        type="primary"
      />
      <Separator height={40} />
      <FlexView alignItems="flex-end">
        <Button
          label="Submit"
          size="small"
          isDisabled={submitDisabled}
          onClick={handleSubmit}
          isBusy={isProcessing}
        />
      </FlexView>
    </FlexView>
  );
};

export default AcLedMappingResultFeedback;
